import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface GenerateBusinessUnitIntroduction {
  actionName: 'generateBusinessUnitIntroduction';
  request: mtechnavi.api.company.IGenerateBusinessUnitIntroductionRequest;
}

export const generateBusinessUnitIntroduction = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.company.IGenerateBusinessUnitIntroductionRequest
) => {
  const generateMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/GenerateBusinessUnitIntroduction';

  return worker.invokeListRequest(generateMethodName, {
    prompt: req.prompt,
  });
};
